/** Shared status values for feature opex NR events — avoid hardcoded "success"/"failure". */
export enum FEATURE_NR_CALL_STATUS {
    SUCCESS = "success",
    FAILURE = "failure",
    LOADING = "loading",
    TIMEOUT = "timeout",
    SKIPPED = "skipped",
    REJECTED = "rejected",
}
